export default function PaperCheckModule(callback, isOnPremiseDeployMode) {
    if (isOnPremiseDeployMode) {
        let fragments = [];
        return { fragments };
      }
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'help-tab',
            // 定义控件的以及图标，文字等信息
            template: '<gtab class="hide" text="phantom_online:paperCheck.paperCheckTool" name="paper-check-tab" group="toolbar-tab" body="fv--paper-check-tab-paddle" @portfolio.unsupport></gtab>',
        },
    ];
    return {fragments};
}